var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortableColumn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.386 0.125526C12.5673 -0.041842 12.8613 -0.041842 13.0426 0.125526L16.2926 3.12553C16.4254 3.2481 16.4651 3.43243 16.3932 3.59258C16.3213 3.75273 16.1521 3.85714 15.9643 3.85714H13.6429V11.1429C13.6429 11.6163 13.2271 12 12.7143 12C12.2015 12 11.7857 11.6163 11.7857 11.1429V3.85714H9.4643C9.27651 3.85714 9.10722 3.75273 9.03535 3.59258C8.96349 3.43243 9.00322 3.2481 9.136 3.12553L12.386 0.125526Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04271 11.8745C3.8614 12.0418 3.56743 12.0418 3.38612 11.8745L0.13607 8.87447C0.00328471 8.7519 -0.0363655 8.56757 0.035506 8.40742C0.107377 8.24727 0.276656 8.14286 0.464413 8.14286L2.78584 8.14286L2.78584 0.857142C2.78584 0.383742 3.20158 -4.88757e-07 3.71441 -4.43924e-07C4.22725 -3.9909e-07 4.64298 0.383743 4.64298 0.857143L4.64298 8.14286L6.96441 8.14286C7.1522 8.14286 7.32149 8.24727 7.39336 8.40742C7.46522 8.56757 7.42549 8.7519 7.29271 8.87447L4.04271 11.8745Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortableColumn);
export default __webpack_public_path__ + "static/media/sortable-column.8d2c33f336b8319186823902fe5b18b4.svg";
export { ForwardRef as ReactComponent };